import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  CsvNotificationType,
  UploadCsvNotification,
} from "./UploadCsvNotification";
import { getUrlFiltersLimitById } from "../../../urlFilters.selectors";

export const CsvInfoNotification = () => {
  const { profileId } = useParams<{ profileId: string }>();
  const limit = useSelector(getUrlFiltersLimitById(profileId));

  return (
    <UploadCsvNotification type={CsvNotificationType.Info}>
      <FormattedMessage id="upload_csv_info" values={{ limit }} />
    </UploadCsvNotification>
  );
};
